import Vue from "vue";
import App from "./App.vue";
import store from "./store";
import router from "./router";
import vuetify from "@/plugins/vuetify";
import * as VueGoogleMaps from "vue2-google-maps";
import GmapCluster from "vue2-google-maps/dist/components/cluster";
import Vue2TouchEvents from "vue2-touch-events";
const MapKey = process.env.VUE_APP_MAP_KEY;

Vue.config.productionTip = false;

Vue.component("GmapCluster", GmapCluster);

Vue.use(Vue2TouchEvents);
Vue.use(VueGoogleMaps, {
  load: {
    key: MapKey,
    libraries: "places,geometry,drawing,visualization",
  },
});

new Vue({
  store,
  router,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");
